<template>
  <div class="content">
    <!-- 开户按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button type="primary" @click="kaihuBtn">新增会员</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin: 0 0 10px 0px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
        >
      </el-form-item>
      <el-form-item label="姓名: " style="margin-left:20px">
        <el-input
          v-model="selectQuery.user_name"
          placeholder="请输入"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号: " style="margin-left:20px">
        <el-input
          v-model="selectQuery.user_phone"
          placeholder="请输入"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="会员卡等级: " style="margin-left:20px">
        <el-input
          v-model="selectQuery.type"
          placeholder="请输入"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectData">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height: 80%">
      <el-table
        border
        :data="dataList"
        style="width: 100%"
        height="100%"
        v-loading="loading"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>

        <el-table-column label="所属门店" width="240" align="center">
          <template slot-scope="scope">
            {{ scope.row.storeName }}
          </template>
        </el-table-column>
        <el-table-column label="会员卡等级" width="160" align="center">
          <template slot-scope="scope">
            <el-tag type="success">{{ scope.row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="会员姓名" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.user_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.user_phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sex }}</span>
          </template>
        </el-table-column>
        <el-table-column label="余额" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column label="会员卡号" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.vip_number }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开卡时间" align="center" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="身份权限" align="center">
      <template slot-scope="scope">
        <span>{{ scope.row.grade==0?"员工":"店长" }}</span>
      </template>
        </el-table-column> -->
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="ejectupdataGoods(scope.row)">
              修改</el-button
            >
            <el-button size="mini" type="danger" @click="deleteAdmin(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增表单 -->
    <el-dialog
      :title="inputTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="所属门店:">
          <el-select
            v-model="form.store_id"
            placeholder="请选择"
            style="width:100%"
          >
            <div v-for="item in storeList" :key="item.id">
              <el-option :label="item.storeName" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
          <el-form-item label="会员卡等级:">
          <el-select
            v-model="form.type"
            placeholder="请选择"
            style="width:100%"
          >
            <div v-for="item in typeList" :key="item.id">
              <el-option :label="item.title" :value="item.title"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" required>
          <el-input v-model="form.user_name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" required>
          <el-input v-model="form.user_phone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-input v-model="form.sex" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.msg"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectUservip,
  deleteUservip,
  updateUservip,
  addUservip,
} from "@/services/vipUser.js";
import {
  selectVipConfig,
} from "@/services/vipConfig.js";
import { selectStore } from "@/services/store";
export default {
  data() {
    return {
      downloadLoading: false,
      storeName: "", //会员名称搜索条件
      dataList: [],
      inputTitle: "新增",
      cover: "",
      fileList: [],
      action: "https://mini-xili.bboycc.cn/uploadFile/add",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" },
      ],
      form: {},
      dialogFormVisible: false,
      storeList: [],
      selectStoreList: [],
      selectQuery: {},
      typeList:[]
    };
  },
  created() {
    // 查询用户登陆数据
    this.form.storeId = this.$store.state.supUser.storeId;
    /* 查询会员卡类型 */
 
    selectVipConfig().then((res) => { 
      this.typeList=res.data
    })
    /* 查询店铺列表 */
    selectStore({ storeName: "" }).then((res) => {
      if (this.$store.state.supUser.role_id === "0") {
        /* 店长 */
        this.selectData();
        this.storeList = res.data;
        return;
      }

      /* 员工 */
      this.selectStoreList = this.form.storeId?.split(",");
      this.storeList = this.selectStoreList?.map((item) => {
        let result = res.data?.find((value) => {
          console.log(value);
          return value.id == item;
        });

        this.selectData();
        return result;
      });
    });
  },
  methods: {
    // 查询
    selectData() {
      console.log(",this.selectQuery==========", this.selectQuery);
      if (this.selectStoreList.length > 0) {
        this.selectQuery.storeId = this.selectStoreList?.join(",");
      } else {
        this.selectQuery.storeId = "";
      }

      selectUservip(this.selectQuery).then((resp) => {
        console.log(resp.data);
        this.loading = false;
        this.dataList = resp.data.data;
      });
    },

    // 新增按钮
    kaihuBtn() {
      this.inputTitle = "新增";
      this.dialogFormVisible = true;
      this.form = {};
    },
    ejectupdataGoods(row) {
      console.log(row);
      this.form = {};
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = JSON.parse(JSON.stringify(row));
    },
    // 表单提交按钮
    sumbmitBtn() {
      console.log(this.form);
      if (!this.form.user_name || !this.form.user_phone) {
        this.$message.error("请填写必填选项");
        return;
      }
      if (this.inputTitle == "新增") {
        addUservip({
          ...this.form,
          create_user: this.$store.state.supUser.sup_username,
        }).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: "新增会员成功!",
            });
            this.selectData();
          } else {
            this.$message({
              type: "info",
              message: "网路错误",
            });
          }
        });
        return;
      }

      updateUservip({
        ...this.form,
        create_user: this.$store.state.supUser.sup_username,
      }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "修改成功!",
          });
          this.selectData();
        } else {
          this.$message({
            type: "info",
            message: "网络错误",
          });
        }
      });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该会员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteUservip({ id: row.id }).then((res) => {
            console.log("deleteUservip", res);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selectData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "所属门店",
          "会员卡号",
          "会员卡类型",
          "会员姓名",
          "性别",
          "手机号",
          "余额",
          "开卡时间",
        ];
        const filterVal = [
          "storeName",
          "vip_number",
          "type",
          "user_name",
          "sex",
          "user_phone",
          "money",
          "create_time",
        ];
        const list = this.dataList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "会员列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
  },
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}

.el-pagination {
  text-align: center;
  margin: 20px;
}

.userNanme:hover {
  cursor: pointer;
}
</style>
